export enum StatusItemManagementEnum {
  all = 'all',
  active = 'active',
  // deleted = 'deleted',
  // error = 'error',
  inactive = 'inactive',
}

export const DefineStatusItemManagement = {
  [StatusItemManagementEnum.all]: 'Tất cả các trạng thái',
  [StatusItemManagementEnum.active]: 'Đang hoạt động',
  // [StatusItemManagementEnum.deleted]: 'Đã xóa',
  // [StatusItemManagementEnum.error]: 'Lỗi',
  [StatusItemManagementEnum.inactive]: 'Không hoạt động',
}

export interface IFilterResponseTreatmentManagement {
  status?: StatusItemManagementEnum
  keyword?: string
}

export interface IFilterProps {
  handleChangeFilter: (value: IFilterResponseTreatmentManagement) => void
}
